import { render, staticRenderFns } from "./ChessRow.vue?vue&type=template&id=7a6cb264&"
import script from "./ChessRow.vue?vue&type=script&lang=ts&"
export * from "./ChessRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports